<template>
    <div class="form-group row mb-2">
        <div class="col-md-6">
            <div v-if="file.new"
                 :class="{'has-error': hasError(`files.${index}`)}"
                 class="fileinput fileinput-new"
                 data-provides="fileinput"
            >
                <span class="btn btn-primary btn-file">
                    <span class="fileinput-new">{{ __('choose_file') }}</span>
                    <span class="fileinput-exists">{{ __('change') }}</span>
                    <input ref="fileinput" type="file" @change="handleFileUpload"/>
                </span>
                <span class="fileinput-filename m-l-sm"></span>
                <a class="close fileinput-exists" data-dismiss="fileinput" href="#" style="float: right">
                    <i class="fa fa-trash"></i>
                </a>
            </div>
            <div v-else>
                <input :disabled="true" :value="file.filename" class="form-control" type="text">
            </div>

            <InputErrors :errors="getErrors(`files.${index}`)"/>
        </div>
        <div :class="{'has-error': hasError(`filenames.${index}.name`)}" class="col">
            <InputWrapper
                :disabled="disabled"
                :errors="getErrors(`filenames.${index}.name`)"
                :value="file.name"
                classNames="form-control"
                @input="emitInput('name', $event)"
            />
        </div>
        <div class="col-md-auto table-icons doc-service text-right">
            <a v-if="!disabled"
               :data-original-title="__('delete')"
               data-placement="top"
               data-toggle="tooltip"
               @click="removeAttachment"
            >
                <i class="fa fa-trash"></i>
            </a>
            <a v-if="file.id && getPermission('downloading_documents_files')"
               :data-original-title="__('download_file')"
               data-placement="top"
               data-toggle="tooltip"
               @click="downloadAttachment"
            >
                <i class="fas fa-paperclip"></i>
            </a>
        </div>
    </div>
</template>

<script>

import hasPermissions from "../../mixins/hasPermissions";
import hasTooltips from "../../mixins/hasTooltips";
import InputWrapper from "../form/InputWrapper";
import inputEmit from "../../mixins/inputEmit";
import hasErrors from "../../mixins/hasErrors";
import InputErrors from "../form/InputErrors";

export default {
    name: "AttachmentRow",
    components: {InputErrors, InputWrapper},
    props: {
        file: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        downloadLink: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    mixins: [hasPermissions, hasTooltips, inputEmit, hasErrors],
    methods: {
        removeAttachment() {
            this.$emit('delete');
            this.clearTooltips();
        },
        handleFileUpload() {
            let file = this.$refs.fileinput.files[0];

            this.emitInput('file', file);
            this.emitInput('name', file.name.substring(0, file.name.lastIndexOf('.')));
        },
        downloadAttachment() {
            if (this.file.id === undefined) return;

            window.open(`${this.downloadLink}download/${this.file.id}`, '_blank');
        },
    },
};
</script>
